import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { useInstance } from 'intact-react';
import { isGT, isLT, isEqual } from './helpers';
export function useStatus(focusDate) {
  var instance = useInstance();
  function isActive(date, type) {
    var isActive = function isActive(values) {
      return Array.isArray(values) ? !!_findInstanceProperty(values).call(values, function (v) {
        return isActive(v);
      }) : isEqual(values, date, type);
    };
    return isActive(instance.get('value'));
  }
  function isInRange(date, type) {
    var _instance$datepicker$ = instance.datepicker.get(),
      range = _instance$datepicker$.range,
      multiple = _instance$datepicker$.multiple;
    var value = instance.get('value');
    if (range) {
      if (!value) {
        return false;
      }
      return value.some(function (_ref) {
        var start = _ref[0],
          end = _ref[1];
        if (!end) {
          end = focusDate.value;
          if (end && isLT(end, start, type)) {
            // maybe the focusDate is less than start date
            var tmp = start;
            start = end;
            end = tmp;
          }
        }
        if (start && end) {
          return isGT(date, start, type) && isLT(date, end, type);
        }
        return false;
      });
    }
    return false;
  }
  return {
    isActive: isActive,
    isInRange: isInRange,
    isDisabled: instance.datepicker.disabled.isDisabled
  };
}